var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "emoji_happy_square_round-_424_",
    "data-name": "emoji_happy_square_round-[#424]",
    d: "M188,6129.5a1.5,1.5,0,0,1-1.5,1.5h-3a1.5,1.5,0,0,1,0-3h3a1.5,1.5,0,0,1,1.5,1.5Zm-13.365,7.05c1.037,4.395,7.693,4.23,8.73-.15.163-.69.748-.9,1.462-.9h.026a1.36,1.36,0,0,1,1.487,1.56c-1.51,7.71-13.169,7.56-14.679-.15-.175-.9.57-1.41,1.487-1.41h.026a1.391,1.391,0,0,1,1.462,1.05ZM176,6129.5a1.5,1.5,0,0,1-1.5,1.5h-3a1.5,1.5,0,0,1,0-3h3a1.5,1.5,0,0,1,1.5,1.5Zm15,15a1.5,1.5,0,0,1-1.5,1.5h-21a1.5,1.5,0,0,1-1.5-1.5v-21a1.5,1.5,0,0,1,1.5-1.5h21a1.5,1.5,0,0,1,1.5,1.5Zm3-22.5a3,3,0,0,0-3-3H167a3,3,0,0,0-3,3v24a3,3,0,0,0,3,3h24a3,3,0,0,0,3-3Z",
    transform: "translate(-164 -6119)",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.d145347e197b764902fafabd82f4bd07.svg";
export { ForwardRef as ReactComponent };